export default __webpack_public_path__ + "static/media/7.39e90f40.jpg";